import React, { Component } from 'react'
import { Link } from 'react-router-dom'

// CSS
import '../css/breadcrumb.css'

export default class Breadcrumb extends Component {
	render() {
		return (
			<div>
				{this.props.structure ? (
						<ul className="breadcrumb">
							{this.props.structure && this.props.structure.map((crumb, i) => {
								return <li key={i}><Link to={`/category/${crumb.permalink}`}>{crumb.title}</Link></li>
							})}
						</ul>
					) : ( null )
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js